export default Object.assign(Number.prototype, {
  isPositiveInteger(value: any): boolean {
    return typeof value === "number" && value > 0 && value % 1 === 0;
  },
});
